import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Code2, Coffee, Triangle, Layers, Server, Braces,
  Database, Cloud, GitBranch, Cpu, Plus
} from "lucide-react";
import styles from "./interviews.module.scss";
import { APIConstant } from "services/api-constant";
import { useTheme } from "context/ThemeContext";

const Interviews = ({ token }) => {
  const { T } = useTheme();

  // ── Tech icon + colour map ──────────────────────────────────────
  const TECH_META = {
    Python:     { icon: Code2,     bg: `${T.green}1F`,  color: T.green  },
    JAVA:       { icon: Coffee,    bg: `${T.amber}1F`,  color: T.amber  },
    Java:       { icon: Coffee,    bg: `${T.amber}1F`,  color: T.amber  },
    React:      { icon: Triangle,  bg: `${T.cyan}1F`,   color: T.cyan   },
    Angular:    { icon: Layers,    bg: `${T.red}1F`,    color: T.red    },
    "Node.js":  { icon: Server,    bg: `${T.green}1F`,  color: T.green  },
    JavaScript: { icon: Braces,    bg: `${T.amber}1F`,  color: T.amber  },
    Database:   { icon: Database,  bg: `${T.purple}1F`, color: T.purple },
    Cloud:      { icon: Cloud,     bg: `${T.cyan}1F`,   color: T.cyan   },
    DevOps:     { icon: GitBranch, bg: `${T.purple}1F`, color: T.purple },
    Others:     { icon: GitBranch, bg: `${T.purple}1F`, color: T.purple },
  };

  const getTechMeta = (name = "") => {
    return TECH_META[name] || { icon: Cpu, bg: `${T.purple}1F`, color: T.purple };
  };

  const navigate = useNavigate();
  const [technologies, setTechnologies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(APIConstant.getTechnologies, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTechnologies(res.data || []);
      } catch (e) {
        console.error("Failed to fetch technologies:", e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return (
    <div className={styles.pageRoot}>
      {/* Header */}
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderLeft}>
          <h2>Interview Tracks</h2>
          <p>Select a technology to view or schedule interviews</p>
        </div>
      </div>

      {/* Grid */}
      {loading ? (
        <div className={styles.loader}>
          <div className={styles.spinner} />
          Loading tracks…
        </div>
      ) : (
        <div className={styles.techGrid}>
          {technologies.map((item, i) => {
            const meta  = getTechMeta(item.name);
            const Icon  = meta.icon;
            return (
              <div
                key={item.id || i}
                className={`${styles.techCard} ${styles.fadeUp}`}
                style={{ animationDelay: `${i * 0.05}s` }}
                onClick={() => navigate(`./list/${item.id}`)}
              >
                <div className={styles.techIcon} style={{ background: meta.bg, color: meta.color }}>
                  <Icon size={24} />
                </div>
                <h5>{item.name}</h5>
                <span className={styles.techCount}>{item.interview_count ?? "—"} interviews</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Interviews;
